export default __webpack_public_path__ + "static/media/bg.39cbe0cb.png";